import React from "react";

import { NavLink, useHistory, useParams } from "react-router-dom";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import CollaboratorForm from "./CollaboratorForm";
import { collaboratorSchema } from "./yupSchema";
import { useUpdateCollaborator, useCollaborator } from "hooks/collaborators";
import {
  Button,
  Flex,
  Spinner,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";

const EditCollaborator = () => {
  const { id } = useParams();
  const { data: { collaborator } = {}, loading } = useCollaborator(id);

  const history = useHistory();

  const methods = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    resolver: yupResolver(collaboratorSchema),
  });
  const toast = useToast();

  const { reset, handleSubmit } = methods;

  const [
    updateCollaborator,
    { loading: loadingUpdate, error },
  ] = useUpdateCollaborator({
    onSuccess: (data) => {
      reset();
      toast({
        title: "Usuário atualizado com sucesso.",
        status: "success",
        duration: 5000,
        isClosable: true,
      }),
        history.push(
          `/sistema/administracao/colaboradores/${data.updateCollaborator.id}`
        );
    },
    onError: (err) => {
      console.log(err);
      toast({
        title: "Ocorreu um erro",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });

  const handleDataBeforeSubmit = (data) => {
    data.cpf = data?.cpf?.replace(/[^0-9]/g, "");
    return data;
  };

  const onSubmit = (data) => {
    data = handleDataBeforeSubmit(data);
    const variables = {
      input: {
        id: id,
        ...data,
      },
    };

    updateCollaborator({ variables: variables });
  };

  const buttonBg = useColorModeValue("governance.700", "governance.700");
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Flex
      direction="column"
      minH="100vh"
      align="center"
      pt={{ sm: "120px", lg: "160px" }}
    >
      <Card w={{ md: "100%", lg: "50%" }}>
        <CardHeader mb="40px">
          <Flex direction="column">
            <Text color={textColor} fontSize="lg" fontWeight="bold" mb="3px">
              Editar Colaborador
            </Text>
          </Flex>
        </CardHeader>
        <CardBody>
          <FormProvider {...methods}>
            <form style={{ width: "100%" }} onSubmit={handleSubmit(onSubmit)}>
              <Flex direction="column" w="100%">
                {loading ? (
                  <>
                    <Flex
                      width="100%"
                      height="100%"
                      justifyContent="center"
                      alignItems="center"
                      fontSize="30px"
                    >
                      <Text fontSize="30px">
                        <Spinner size="xl" w="80px" h="80px" />
                      </Text>
                    </Flex>
                  </>
                ) : (
                  <CollaboratorForm defaultValues={collaborator} />
                )}
                <Flex mt="24px" align={"center"} justify={"flex-end"}>
                  <NavLink to={`/sistema/administracao/colaboradores/${id}`}>
                    <Text
                      mr="20px"
                      fontSize="xs"
                      color={textColor}
                      fontWeight="bold"
                    >
                      Cancelar
                    </Text>
                  </NavLink>
                  <Button
                    isLoading={loadingUpdate}
                    type="submit"
                    variant="no-hover"
                    bg={buttonBg}
                    alignSelf="flex-end"
                    w="100px"
                    h="35px"
                  >
                    <Text fontSize="xs" color="#fff" fontWeight="bold">
                      Atualizar
                    </Text>
                  </Button>
                </Flex>
              </Flex>
            </form>
          </FormProvider>
        </CardBody>
      </Card>
    </Flex>
  );
};

export default EditCollaborator;
